module.exports = __webpack_public_path__ + "static/media/two-and-a-half-garlic.fafa3f69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/two-and-a-half-garlic.jpg
// module id = 255
// module chunks = 1